import { Divider, Grid, Typography } from "@mui/material";
import { type ReactNode } from "react";
import { PaperCard } from "./paper-card";

interface Props {
  title: string;
  children: ReactNode;
}

export const SectionWithTitle = ({ title, children }: Props) => {
  return (
    <PaperCard>
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            position: "sticky",
            top: "56px",
            bgcolor: "background.paper",
            zIndex: 3,
            mb: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>

          <Divider />
        </Grid>

        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </PaperCard>
  );
};
